<template>
    <div>
        <v-toolbar class="mb-3 secondary" elevation="1" dense rounded>
            <v-breadcrumbs large :items="[{text:'Administration'},{text:'Stock Journal'},{text:'Roles'}]"></v-breadcrumbs>
        </v-toolbar>
        <!-- <StockJournalRoleEdit/> -->
        <StockJournalRolesList/>
        <!-- <ul>
            <li v-for="role in roles" :key="role.id">
                {{ role.name }}
                 <ul>
                    <li v-for="item in items" :key="item.id">{{ item.name }}</li>
                </ul>
                <ul>
                    <li v-for="account in accounts" :key="account.id">{{ account.name }}</li>
                </ul>
                <ul>
                    <li v-for="warehouse in warehouses" :key="warehouse.id">{{ warehouse.name }}</li>
                </ul>
            </li>
        </ul> -->
    </div>
</template>

<script>
// import StockJournalRoleEdit from './../../components/warehouse/StockJournalRoleEdit';
import StockJournalRolesList from './../../components/administration/StockJournalRolesList';

export default {
    name: 'StockJournalRoles',
    components: {  StockJournalRolesList },
    mounted () {

    },
    data () {
        return {

        }
    },
}
</script>